import BannerWrapper from './BannerWrapper'

export default BannerWrapper
